<style scoped>
@import url("../assets/css/index.css");
</style>

<template>
  <div class="search-content">
    <van-search
      placeholder="输入你要搜索的古籍名称"
      v-model="key"
      show-action
      @search="onSearch"
      @cancel="onCancel"
      :clearable="false"
      @focus="clearShow"
      background="rgba(143,94,63,1)"
    >
      <img slot="left-icon" src="../assets/image/icon_v2/search.png" class="search-icon" />
      <img
        slot="right-icon"
        src="../assets/image/icon_v2/cancel_icon@2x.png"
        v-show="clear"
        @click="clearSearchInput"
        class="search-icon"
      />
    </van-search>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()">
      <van-grid :column-num="2" :gutter="10">
        <van-grid-item v-for="(book,item) in books" :key="item" @click="info(book.book_id)">
          <van-image :src="book.cover" width="82" height="101" />
          <div class="grid-item-title">{{book.name}}</div>
          <div class="grid-item-author">{{book.author}}</div>
        </van-grid-item>
      </van-grid>
    </van-list>
  </div>
</template>

<script>
import { Search, Grid, GridItem, Image, List } from "vant";
export default {
  data() {
    return {
      books: [],
      loading: false,
      finished: false,
      currentPage: 0,
      categoryId: 1,
      key: null,
      clear: true
    };
  },
  methods: {
    onLoad() {
      setTimeout(() => {
        var page = this.currentPage + 1;

        this.onSearch(page);

        // 加载状态结束
        this.loading = false;
      }, 500);
    },
    onSearch(page = 1, pageSize = 10) {
      if (this.key) {
        this.$store.commit("setRecentWord", this.key);
        var that = this;
        var params = {
          keyword: this.key,
          channel: 'h5',
          page: page,
          page_size: pageSize
        };
        this.$api.get("/book/search", { params }).then(function(res) {
          var data = res.data.data;
          if (data.current_page == 1 || data.current_page == 0) {
            that.currentPage = 1;
            that.books = res.data.data.books;
          } else {
            that.currentPage = data.current_page;
            that.books = that.books.concat(data.books);
          }
          if(data.length<1) {
            that.finished = false;
          }
          if (that.currentPage == data.total_pages) {
            that.finished = true;
          }
        });
      }
    },
    onCancel() {
      this.$router.push({ path: "/" });
    },
    clearShow() {
      this.clear = true;
    },
    clearSearchInput() {
      this.key = null;
      this.clear = false;
    },
    info(bookId) {
      this.$router.push({ path: "/info/" + bookId });
    }
  },
  created() {
    this.key = this.$route.params.key;

    const hashLocation = this.$route.path
		const url = "https://m.kanguji.com"+hashLocation
		this.$matomo.setCustomUrl(url);
  },
  components: {
    [Search.name]: Search,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [List.name]: List
  }
};
</script>


// WEBPACK FOOTER //
// src/components/search.vue